<div class="page-head-section">
  <p>News</p>
</div>

<div class="news-wrap">
  <div class="news-section">
    <div class="ui-g">
      <div *ngFor="let data of news" class="ui-g-4 ui-lg-4 ui-md-6 ui-sm-12">
        <div class="news-card">
          <div class="image">
            <div
              class="news-image"
              [style.backgroundImage]="'url(' + data?.link + ')'"
            ></div>
          </div>
          <div class="news-image-line"></div>
          <h2 class="news-heading">
            {{ data.title }}
          </h2>
          <p class="news-content">
            {{ data.description }}
          </p>
          <a (click)="newsDetails(data._id)" class="read-more">Read More</a>
        </div>
      </div>
    </div>
  </div>
</div>
